<script lang="ts">
  import { cn } from '$lib/utils';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';
  import type { CtaCardStoryblok } from '$types/bloks';

  let className: string | undefined = undefined;
  export { className as class };

  export let cta: CtaCardStoryblok | null = null;
</script>

{#if cta && cta.link}
  {@const { href, target, rel } = $getAnchorFromCmsLink(cta.link)}
  <!-- CTA -->
  <a
    {href}
    {target}
    {rel}
    class={cn('relative flex bg-primary/4 rounded-sm items-center justify-center', className)}
  >
    <span class="w-fit text-primary text-xl">{cta.label}</span>
  </a>
  <!-- END CTA -->
{/if}
